import { Col, Row } from 'antd'
import ComprobantDetailPaymentBodyBill from './components/ComprobantDetailPaymentBodyBill/ComprobantDetailPaymentBodyBill'
import ComprobantDetailPaymentBodyImageDetail from './components/ComprobantDetailPaymentBodyImageDetail/ComprobantDetailPaymentBodyImageDetail'
import { useComprobantDetailPaymentBody } from './hooks/useComprobantDetailPaymentBody'
import './styles.css'

const ComprobantDetailPaymentBody = () => {

    const { comprobantDetailData, detailPaymentData } = useComprobantDetailPaymentBody()
    return (
        <Row className='comprobant-detail-payment-body' style={{ width: '100%' }}>
            <Col span={15} style={{ paddingRight: 48 }}>
                <ComprobantDetailPaymentBodyBill detailPaymentData={detailPaymentData} />
            </Col>
            <Col span={9} style={{ paddingLeft: 24 }}>
                <ComprobantDetailPaymentBodyImageDetail
                    comprobantDetailData={comprobantDetailData}
                />
            </Col>
        </Row>
    )
}

export default ComprobantDetailPaymentBody
